'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;
// import slide1 from 'containers/Home/home-slide-1.jpg';
// import slide2 from 'containers/Home/home-slide-2.jpg';
// import slide3 from 'containers/Home/home-slide-3.jpg';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _validation = require('utils/validation');

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _lodash = require('lodash');

var _reactDropzone = require('react-dropzone');

var _reactDropzone2 = _interopRequireDefault(_reactDropzone);

var _FirebaseAuth = require('helpers/FirebaseAuth');

var _FirebaseAuth2 = _interopRequireDefault(_FirebaseAuth);

var _STAR = require('assets/img/STAR.gif');

var _STAR2 = _interopRequireDefault(_STAR);

var _camera3x = require('assets/img/account/camera@3x.png');

var _camera3x2 = _interopRequireDefault(_camera3x);

var _phoneIcon3x = require('assets/img/account/phoneIcon@3x.png');

var _phoneIcon3x2 = _interopRequireDefault(_phoneIcon3x);

var _mailIcon3x = require('assets/img/account/mailIcon@3x.png');

var _mailIcon3x2 = _interopRequireDefault(_mailIcon3x);

var _genderIcon3x = require('assets/img/account/genderIcon@3x.png');

var _genderIcon3x2 = _interopRequireDefault(_genderIcon3x);

var _accountIcon3x = require('assets/img/account/accountIcon@3x.png');

var _accountIcon3x2 = _interopRequireDefault(_accountIcon3x);

var _calendar2x = require('assets/img/account/calendar@2x.png');

var _calendar2x2 = _interopRequireDefault(_calendar2x);

var _user = require('redux/modules/user');

var userActions = _interopRequireWildcard(_user);

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _lib = require('helpers/lib');

var _Constant = require('helpers/Constant');

var _support = require('helpers/support');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MESSAGE = {
  UPDATE_PROFILE_SUCCESS: {
    status: 'success',
    title: 'Thông Báo',
    message: 'Cập nhật thông tin tài khoản thành công.'
  },
  UPDATE_PROFILE_ERROR: {
    status: 'error',
    title: 'Lỗi',
    message: 'Đã có lỗi xảy ra.'
  }
};
// const slides = [slide1, slide2, slide3];
var ProfileMobile = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    success: state.user.success,
    loadError: state.user.loadError,
    loading: state.user.loading
  };
}, (0, _extends3.default)({}, authActions, userActions)), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(ProfileMobile, _Component);

  function ProfileMobile() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ProfileMobile);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ProfileMobile.__proto__ || (0, _getPrototypeOf2.default)(ProfileMobile)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      newUser: {
        _id: _this.props.user._id,
        email: _this.props.user.email,
        name: _this.props.user.profile.name,
        avatar: _this.props.user.profile.picture,
        dob: _this.props.user.profile.dob,
        phone: _this.props.user.phone,
        gender: _this.props.user.profile.gender,
        isUpdatedAvatar: false
      },
      avatar: [],
      errors: {},
      validation: {},
      edited: false,
      infoMessage: {
        status: '',
        title: '',
        message: ''
      },
      showModal: false,
      birthday: 'mm/dd/yyyy'
    }, _this.handleChange = function (event) {
      var field = event.target.name;
      var value = event.target.value;
      if (event.target.type === 'checkbox') {
        value = event.target.checked;
      }
      var obj = _this.state.newUser;
      obj[field] = value;
      _this.setState({ newUser: obj, edited: true });
    }, _this.toggleModal = function () {
      _this.setState({
        showModal: !_this.state.showModal
      });
    }, _this.responsePhone = function (response) {
      if (response) {
        _this.props.activePhone(response);
      }
    }, _this.onBack = function () {
      _reactRouter.browserHistory.goBack();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ProfileMobile, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.success) {
        this.props.clearSuccessStatus();
        this.toggleModal();
        this.props.loadAuth();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!(0, _lodash.isEqual)(this.props.loadError, nextProps.loadError) && nextProps.loadError !== null && nextProps.loadError !== undefined) {
        _support.Helper.prints('loadError: ', nextProps.loadError);
        var infoMessage = (0, _extends3.default)({}, MESSAGE.UPDATE_PROFILE_ERROR, {
          message: nextProps.loadError.message
        });
        this.setState({ infoMessage: infoMessage, showModal: true });
      }
      if (this.props.success !== nextProps.success && nextProps.success !== null && nextProps.success !== undefined) {
        var _infoMessage = MESSAGE.UPDATE_PROFILE_SUCCESS;
        this.setState({ infoMessage: _infoMessage, showModal: true });
      }
    }
  }, {
    key: 'onDrop',
    value: function onDrop(acceptedFiles) {
      var obj = this.state.newUser;
      obj.isUpdatedAvatar = true;
      this.setState({ newUser: obj, avatar: acceptedFiles, edited: true });
    }
  }, {
    key: 'onSubmit',
    value: function onSubmit(event) {
      if (event) {
        event.preventDefault();
      }
      var surveyValidation = (0, _validation.createValidator)({
        phone: [_validation.required, _validation.phone],
        name: [_validation.required],
        email: [_validation.required, _validation.email]
      });
      var errors = surveyValidation(this.state.newUser);
      if ((0, _lodash.isEmpty)(errors)) {
        this.setState({ validation: {} });
        var newUser = this.state.newUser;
        var name = (0, _lib.encrypt)((0, _lib.createImageName)({
          user: newUser._id,
          type: 'avatar'
        }));
        newUser.encryptName = name;
        this.props.updateUser(this.state.newUser, this.state.avatar);
      } else {
        this.setState({ validation: errors });
      }
    }
  }, {
    key: 'infoClass',
    value: function infoClass(code) {
      var styles = require('./Profile.scss');
      switch (code) {
        case 'error':
          return styles.error;
        case 'warning':
          return styles.warning;
        case 'success':
          return styles.success;
        default:
          return '';
      }
    }
  }, {
    key: 'focusDate',
    value: function focusDate() {
      this.type = 'date';
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./Profile.scss');
      var _state = this.state,
          newUser = _state.newUser,
          showModal = _state.showModal,
          avatar = _state.avatar,
          validation = _state.validation,
          errors = _state.errors,
          infoMessage = _state.infoMessage,
          birthday = _state.birthday;
      var _props = this.props,
          user = _props.user,
          loading = _props.loading;

      return _react2.default.createElement(
        'div',
        { className: styles.profileMobile },
        loading && _react2.default.createElement(
          'div',
          { className: styles.loadingFade },
          _react2.default.createElement(
            'div',
            { className: styles.loading },
            _react2.default.createElement('img', { src: _STAR2.default })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.thumbnailContainer },
          _react2.default.createElement(
            _reactDropzone2.default,
            {
              className: styles.dropzone,
              onDrop: this.onDrop.bind(this),
              accept: 'image/*',
              multiple: false,
              style: { float: 'left', marginRight: '10px' }
            },
            newUser.isUpdatedAvatar && avatar.length > 0 && _react2.default.createElement(
              'div',
              { style: { float: 'left' } },
              avatar.map(function (image) {
                var imgBackGr = {
                  backgroundImage: 'url:(' + image.preview + ')'
                };
                return image.type.split('/')[0] === 'video' ? _react2.default.createElement(
                  'div',
                  { key: image.lastModified },
                  _react2.default.createElement('video', {
                    src: image.preview,
                    key: image.lastModified,
                    width: '100%',
                    height: '250px',
                    controls: true
                  })
                ) : _react2.default.createElement('img', {
                  src: image.preview,
                  key: image.lastModified,
                  style: imgBackGr,
                  className: styles.avatar
                });
              })
            ),
            !newUser.isUpdatedAvatar && newUser.avatar && _react2.default.createElement(
              'div',
              { className: styles.avaView },
              _react2.default.createElement('img', {
                src: (0, _lib.getUrlImage)(newUser.avatar),
                style: {
                  backgroundImage: 'url:(' + (0, _lib.getUrlImage)(newUser.avatar) + ')'
                },
                className: styles.avatar
              }),
              _react2.default.createElement('img', { src: _camera3x2.default, className: styles.cameraIcon }),
              _react2.default.createElement(
                'div',
                { className: styles.btnAvatar },
                '\u0110\u1ED5i avatar'
              )
            ),
            !newUser.isUpdatedAvatar && !newUser.avatar && _react2.default.createElement(
              'div',
              { className: styles.avaView },
              _react2.default.createElement('img', {
                src: _Constant.defaultAvatar,
                style: { backgroundImage: 'url:(' + _Constant.defaultAvatar + ')' },
                className: styles.avatar
              }),
              _react2.default.createElement('img', { src: _camera3x2.default, className: styles.cameraIcon }),
              _react2.default.createElement(
                'div',
                { className: styles.btnAvatar },
                '\u0110\u1ED5i avatar'
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.formUpdateProfile },
          _react2.default.createElement(
            'div',
            { className: 'row profileForm' },
            _react2.default.createElement(
              'div',
              { className: styles.formProfiles },
              _react2.default.createElement(
                'form',
                { onSubmit: this.onSubmit.bind(this) },
                _react2.default.createElement(
                  'div',
                  {
                    className: styles.formGroup + (!(0, _lodash.isEmpty)(validation) && validation.name || !(0, _lodash.isEmpty)(errors) && errors.name ? ' has-error' : '')
                  },
                  _react2.default.createElement('img', { src: _accountIcon3x2.default, className: styles.smallIcon }),
                  _react2.default.createElement('input', {
                    className: 'form-control ' + styles.fullWidth,
                    type: 'text',
                    name: 'name',
                    placeholder: 'B\u1EA1n t\xEAn g\xEC?',
                    value: newUser.name,
                    onChange: this.handleChange
                  }),
                  !(0, _lodash.isEmpty)(validation) && validation.name && _react2.default.createElement(
                    'small',
                    { className: 'help-block' },
                    validation.name
                  ),
                  !(0, _lodash.isEmpty)(errors) && errors.name && _react2.default.createElement(
                    'small',
                    { className: 'help-block' },
                    errors.name
                  )
                ),
                _react2.default.createElement(
                  'div',
                  {
                    className: styles.formGroup + (!(0, _lodash.isEmpty)(validation) && validation.gender || !(0, _lodash.isEmpty)(errors) && errors.gender ? ' has-error' : '')
                  },
                  _react2.default.createElement('img', { src: _genderIcon3x2.default, className: styles.smallIcon }),
                  _react2.default.createElement(
                    'select',
                    {
                      className: 'form-control',
                      placeholder: 'Gi\u1EDBi t\xEDnh',
                      name: 'gender',
                      value: newUser.gender,
                      onChange: this.handleChange
                    },
                    _react2.default.createElement(
                      'option',
                      { value: 'female' },
                      'N\u1EEF'
                    ),
                    _react2.default.createElement(
                      'option',
                      { value: 'male' },
                      'Nam'
                    ),
                    _react2.default.createElement(
                      'option',
                      { value: 'other' },
                      'Kh\xE1c'
                    )
                  ),
                  !(0, _lodash.isEmpty)(validation) && validation.gender && _react2.default.createElement(
                    'small',
                    { className: 'help-block' },
                    validation.gender
                  ),
                  !(0, _lodash.isEmpty)(errors) && errors.gender && _react2.default.createElement(
                    'small',
                    { className: 'help-block' },
                    errors.gender
                  )
                ),
                _react2.default.createElement(
                  'div',
                  {
                    className: styles.formGroup + (!(0, _lodash.isEmpty)(validation) && validation.dob || !(0, _lodash.isEmpty)(errors) && errors.dob ? ' has-error' : '')
                  },
                  _react2.default.createElement('img', { src: _calendar2x2.default, className: styles.smallIcon }),
                  _react2.default.createElement('input', {
                    className: 'form-control ' + (!newUser.dob ? styles.empty : ''),
                    type: 'date',
                    name: 'dob',
                    value: newUser.dob ? (0, _moment2.default)(new Date(newUser.dob)).format('YYYY-MM-DD') : birthday,
                    onChange: this.handleChange
                  }),
                  !(0, _lodash.isEmpty)(validation) && validation.dob && _react2.default.createElement(
                    'small',
                    { className: 'help-block' },
                    validation.dob
                  ),
                  !(0, _lodash.isEmpty)(errors) && errors.dob && _react2.default.createElement(
                    'small',
                    { className: 'help-block' },
                    errors.dob
                  )
                ),
                _react2.default.createElement(
                  'div',
                  {
                    className: styles.formGroup + (!(0, _lodash.isEmpty)(validation) && user.phone && !user.verifiedPhone ? ' has-error' : '')
                  },
                  _react2.default.createElement('img', { src: _phoneIcon3x2.default, className: styles.smallIcon }),
                  user && _react2.default.createElement(
                    'div',
                    { className: styles.phoneActive },
                    user.phone
                  ),
                  user && user.phone && !user.verifiedPhone && _react2.default.createElement(
                    _FirebaseAuth2.default,
                    {
                      onResponse: this.responsePhone,
                      phone: user.phone.replace('+84', '')
                    },
                    function (p) {
                      return _react2.default.createElement(
                        'button',
                        (0, _extends3.default)({}, p, { className: styles.phone }),
                        _react2.default.createElement('i', {
                          className: 'fa fa-check ' + styles.icon,
                          'aria-hidden': 'true'
                        }),
                        'X\xE1c th\u1EF1c s\u1ED1 \u0111i\u1EC7n tho\u1EA1i'
                      );
                    }
                  ),
                  user && !user.phone && !user.verifiedPhone && _react2.default.createElement(
                    _FirebaseAuth2.default,
                    { onResponse: this.responsePhone },
                    function (p) {
                      return _react2.default.createElement(
                        'div',
                        { className: styles.addPhone },
                        _react2.default.createElement(
                          'span',
                          null,
                          'B\u1EA5m v\xE0o \u0111\xE2y \u0111\u1EC3 '
                        ),
                        _react2.default.createElement(
                          'button',
                          (0, _extends3.default)({}, p, { className: styles.phone }),
                          _react2.default.createElement('i', {
                            className: 'fa fa-plus ' + styles.icon,
                            'aria-hidden': 'true'
                          }),
                          'Th\xEAm s\u1ED1 \u0111i\u1EC7n tho\u1EA1i'
                        )
                      );
                    }
                  ),
                  user && user.phone && user.verifiedPhone && _react2.default.createElement(
                    'div',
                    { className: styles.verifiedView },
                    '\u0110\xE3 x\xE1c nh\u1EADn'
                  ),
                  !(0, _lodash.isEmpty)(validation) && validation.phone && _react2.default.createElement(
                    'small',
                    { className: styles.errorText },
                    validation.phone
                  ),
                  !(0, _lodash.isEmpty)(errors) && errors.phone && _react2.default.createElement(
                    'small',
                    { className: 'help-block' },
                    errors.phone
                  )
                ),
                _react2.default.createElement(
                  'div',
                  {
                    className: styles.formGroup + (!(0, _lodash.isEmpty)(validation) && validation.email || !(0, _lodash.isEmpty)(errors) && errors.email ? ' has-error' : '')
                  },
                  _react2.default.createElement('img', { src: _mailIcon3x2.default, className: styles.smallIcon }),
                  user.accountType !== 'local' ? _react2.default.createElement('input', {
                    className: 'form-control ' + styles.fullWidth,
                    type: 'text',
                    name: 'email',
                    placeholder: '\u0110\u1ECBa ch\u1EC9 email (kh\xF4ng b\u1EAFt bu\u1ED9c)',
                    value: newUser.email,
                    onChange: this.handleChange
                  }) : _react2.default.createElement(
                    'div',
                    { className: styles.email },
                    user && user.email
                  ),
                  !(0, _lodash.isEmpty)(validation) && validation.email && _react2.default.createElement(
                    'small',
                    { className: 'help-block' },
                    validation.email
                  ),
                  !(0, _lodash.isEmpty)(errors) && errors.email && _react2.default.createElement(
                    'small',
                    { className: 'help-block' },
                    errors.email
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.action },
            _react2.default.createElement(
              'div',
              { className: styles.btnSave, onClick: this.onSubmit.bind(this) },
              'L\u01B0u th\xF4ng tin'
            )
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal,
          {
            onHide: this.toggleModal.bind(this),
            show: showModal,
            className: 'modal-alert-mobile modal-profile ' + styles.modalAlert
          },
          _react2.default.createElement(
            _reactBootstrap.Modal.Header,
            { closeButton: true },
            _react2.default.createElement(
              'div',
              {
                className: styles.modalHeader + ' ' + this.infoClass.call(this, infoMessage.status)
              },
              _react2.default.createElement(
                'span',
                { className: styles.tilte },
                infoMessage.title
              )
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Modal.Body,
            { className: styles.modalBody },
            _react2.default.createElement(
              'div',
              { className: styles.contentAlert },
              infoMessage.message
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Modal.Footer,
            null,
            _react2.default.createElement(
              'div',
              { className: styles.actionButtons },
              _react2.default.createElement(
                'div',
                { className: styles.btnLogin, onClick: this.toggleModal.bind(this) },
                'X\xE1c nh\u1EADn'
              )
            )
          )
        )
      );
    }
  }]);
  return ProfileMobile;
}(_react.Component), _class2.propTypes = {
  user: _react.PropTypes.object,
  loading: _react.PropTypes.bool,
  updateUser: _react.PropTypes.func.isRequired,
  success: _react.PropTypes.bool,
  clearSuccessStatus: _react.PropTypes.func,
  load: _react.PropTypes.func,
  loadAuth: _react.PropTypes.func,
  activePhone: _react.PropTypes.func,
  loadError: _react.PropTypes.object
}, _temp2)) || _class);
exports.default = ProfileMobile;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/AccountManagement/Profile.js
// module id = 1529
// module chunks = 0